'use strict';

/** @WebglMapController */
const WebglMapController = function WebglMapController ($element, $scope, $timeout, $window, AnalyticsService, sbAuth, Flux, ShareService) {
  const DataCaptureStore = Flux.Store.get('DataCaptureStore');
  const SiteStore = Flux.Store.get('SiteStore');
  const TopControlsStore = Flux.Store.get('TopControlsStore');
  const WebglMapStore = Flux.Store.get('WebglMapStore');

  this.active = false;
  this.pc_rgb = false;
  this.mesh_gltf = false;
  this.pc_rgbClass = false;
  this.mesh_gltfClass = false;
  this.enableShare = true;
  this.sceneDescriptor = {
    pointCloudRgb: null
  };

  /* not directly used by the WebglMapController but the share.tpl.html */
  this.SHARE_SERVICE = ShareService;   
  this.updateCanShareSite = ShareService.updateCanShareSite;    
  this.onCopyShareUrl = ShareService.onCopyShareUrl;    
  this.onCopyShareEmbed = ShareService.onCopyShareEmbed;    
  this.getShareIframeCode = ShareService.getShareIframeCode;    
  this.handleShareClick = ShareService.handleShareClick;

  this._handleWebglMapStoreChange = () => {
    this.currentLayerType = TopControlsStore.get('currentLayerType');
    this.active = WebglMapStore.get('active');

    //appear once only
    if (!this.pc_rgb) {
      this.pc_rgb = WebglMapStore.get('pc_rgb');
    }

    if (!this.mesh_gltf) {
      this.mesh_gltf =  WebglMapStore.get('mesh_gltf');
    }

    //which view using css
    this.mesh_gltfClass = WebglMapStore.get('mesh_gltf');
    this.pc_rgbClass = WebglMapStore.get('pc_rgb');

    if (this.active && this.active !== 'tileLayer') {
      this._buildScene();
      $element.addClass('active');
    }
    else {
      $element.removeClass('active');
    }
  };

  //reset maps on site or datacapture change
  this._handleWebGlMapsReset = () => {
    $timeout(() => {
      SiteStore.getSiteSettingsCanShare().then((res) => {
        this.canShareSite = res.canShareSite;
      });

      this.pc_rgb = false;
      this.mesh_gltf = false;
      this.active = false;
      this.pc_rgbClass = false;
      this.mesh_gltfClass = false;
    });
  };

  this._buildScene = () => {
    const initData = $window.document.querySelector('#init-data') && JSON.parse($window.document.querySelector('#init-data').getAttribute('value'));
    const webglLayerTypes = ['pc_rgb', 'mesh_gltf'];
    const currentDataCapture = WebglMapStore.get('currentDatacapture');
    const currentWebglLayers = {};

    if (!currentDataCapture && (!currentWebglLayers.pc_rgb && !currentWebglLayers.mesh_gltf)) {
      return;
    }

    currentDataCapture.dataCaptureLayers.forEach((layer) => {
      if (webglLayerTypes.indexOf(layer.layerType) > -1) {
        currentWebglLayers[layer.layerType] = layer;
      }
    });

    sbAuth.getToken().then((token) => {
      const moment = require('moment');
      const getLayerUrl = (type) => {
        let layerData;
        let file;

        switch (type) {
        case 'mesh':
          layerData = currentWebglLayers.mesh_gltf.layerData;
          file = 'mesh.gltf';
          break;
        case 'point':
          layerData = currentWebglLayers.pc_rgb.layerData;
          file = 'cloud.js';
          break;
        }

        return `${initData.resourceProxyUri.replace('{s}', 'a')}/${token}/data_captures/${currentDataCapture.id}/${layerData}/${file}`;
      };

      if (currentWebglLayers.mesh_gltf) {
        this.sceneDescriptor.meshURL = getLayerUrl('mesh');
      }

      if (currentWebglLayers.pc_rgb) {
        this.sceneDescriptor.pointCloudRgb = getLayerUrl('point');
      }

      this.sceneDescriptor.dataMeta = {
        siteName: SiteStore.get('current').name,
        date: moment(currentDataCapture.capturedAt).format('MMM DD YYYY'),
        datacaptureID: currentDataCapture.id
      };
    });
  };

  // Handling analytics coming from Mesh Booster
  $window.addEventListener('message', (event) => {
    const data = event.data;
    const sendAnalytics = (name, eventData = data.eventData) => {
      AnalyticsService.track('[CORE] 3D Mesh Viewer', name, eventData);
    };

    if (data.src === 'analytics') {
      switch (data.eventType) {
      case 'loadTime':
        sendAnalytics('GLTF Load Time');
        break;
      case 'timeSpent':
        sendAnalytics('Time Spent in Viewer');
        break;
      case 'controlActivated':
        sendAnalytics('Control Activated');
        break;
      case 'datacaptureViewed':
        sendAnalytics('Datacapture Viewed');
        break;
      }
    }
  });

  DataCaptureStore.on(DataCaptureStore.Events.Changed, this._handleWebGlMapsReset.bind(this), $scope);
  SiteStore.on(SiteStore.Events.Changed, this._handleWebGlMapsReset.bind(this), $scope);
  WebglMapStore.on(WebglMapStore.Events.Changed, this._handleWebglMapStoreChange.bind(this), $scope);
};

WebglMapController.$inject = ['$element', '$scope', '$timeout', '$window', 'AnalyticsService', 'sbAuth', 'sbFlux', 'ShareService'];

module.exports = WebglMapController;



// WEBPACK FOOTER //
// ./src/app/dash/webglMap/WebglMapController.js